import { CustomSelect } from "../../../ui";
import { OutletRoleEnum } from "../outlet-role-enum";
import { outletRoleLabels } from "../outlet-role-labels";

export const OutletRoleSelect = (props) => (
  <CustomSelect
    id="outlet-role"
    options={Object.values(OutletRoleEnum).map((value) => ({
      value: value,
      label: outletRoleLabels[value],
    }))}
    {...props}
  />
);
